import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 11h5v4h6v-4h5v9h-16v-9","key":"svg-0"}],["path",{"d":"M9 4h6v4h-6l0 -4","key":"svg-1"}]]

const IconBrandUnsplash = createReactComponent('outline', 'brand-unsplash', 'BrandUnsplash', __iconNode);

export default IconBrandUnsplash;